export const convertVersionStringToNumber = (version: string): number => {
  return Number(version.split(".").join(""));
};
